import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { PageMeta } from '../../../components/meta/PageMeta';
import { DashNavbar } from '../../navbar/DashNavbar/DashNavbar';
import { FilterNavbar } from '../../navbar/FilterNavbar/FilterNavbar';
import { MimicHeader } from '../../navbar/MimicHeader';

export const DashLayout = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      <PageMeta title="Dashboard" />
      <MimicHeader />
      <DashNavbar />
      <FilterNavbar />
      <div className="content min-vh-100">
        <Outlet />
      </div>
    </>
  );
};
